import React from 'react'

const Index = ({singleRole, last}) => {

	return(
		<tr id={singleRole.id} className={last ? "bottom":""}>
			<td><span className="name">{singleRole.name ? singleRole.name:"Utilgjengelig"}</span></td>
			<td>{singleRole.role ? singleRole.role:"Utilgjengelig"}</td>
			<td><a target="_blank" rel="noopener noreferrer" href={`https://www.linkedin.com/search/results/all/?keywords=${encodeURIComponent(singleRole.name)}`}><button><i className="fab fa-linkedin-in"></i></button></a><a target="_blank" rel="noopener noreferrer" href={`https://www.1881.no/?query=${encodeURIComponent(singleRole.name)}`}><button><i className="fas fa-phone"></i></button></a></td>
		</tr>
	)
}

export default Index